
import Vue from "vue";
// import Nav from "@/components/Nav.vue";
import SideBar from "@/components/SideBar.vue";

export default Vue.extend({
  name: "App",
  components: {
    //     Nav,
    SideBar,
  },

  data: () => ({
    //
  }),
  watch: {},
});
